<template lang="pug">

    v-card(
        :color="itemColor"
        :class="{'highlighted-border': highlightCardBorder}"
    )
        v-list-item.px-1(:color="itemColor" @click="expandable && onExpand ? onExpand() : null")
            v-list-item-avatar.mr-0
                v-btn(
                    v-if="expandable"
                    icon
                    ripple
                    @click.stop="onExpand();"
                )
                    v-icon.text-white(v-if="isExpanded")
                        | mdi-chevron-down
                    v-icon.text-white(v-else)
                        | mdi-chevron-right

                v-simple-checkbox(
                    v-else-if="selectable"
                    v-model="isChecked"
                    dark
                    :ripple="false"
                    @click.stop="onClickIsChecked(isChecked)"
                )

            v-list-item-content.pl-0(:style="'flex-grow: ' + leftFlexGrow +';'" :class="[dense ? 'py-2' : 'py-4', `text-${titleAlignment}`]")
                v-list-item-title.text-white(style="font-weight: 500;")
                    slot(name="title")
                        span.ml-0.white--text  
                            template(v-if="icon?.length > 0")
                                v-icon.mr-1(color="white") {{ icon }}
                            | {{ itemNumber ? `(${itemNumber}) ` : '' }}{{ title }}
                        v-icon.ml-2(color="white" small v-if="appendNotesIconToTitle") mdi-pencil-box-outline
                        slot(name="titleAppend")

                v-list-item-subtitle(v-if="subtitle" :style="{ 'color': subtitleColor || 'var(--white)' }")
                    slot(name="subtitle")
                        | {{ subtitle }}

                slot(name="moreSubtitles")

            v-list-item-content.my-0.mr-1(:style="(contentRightTop || contentRightBottom) ? 'flex-grow: '+rightFlexGrow+'; min-width: 85px;' : 'flex-grow: '+rightFlexGrow+';'" :class="dense ? 'py-2' : 'py-4'")
                v-list-item-subtitle.text-white.text-right
                    slot(name="rightTop")
                        | {{ contentRightTop || '' }}

                v-list-item-subtitle.text-white.text-right
                    slot(name="rightBottom")
                        | {{ contentRightBottom || '' }}

            v-list-item-action.mx-1(v-if="rightActionIcon")
                slot(name="rightActionIcon")
                    template(v-if="rightActionClick")
                        v-btn(icon dark @click.stop="rightActionClick()")
                            v-icon(dark) {{ rightActionIcon }}
                    template(v-else)
                        v-icon {{ rightActionIcon }}

        slot(name="body")
            v-list-item-subtitle.px-8.pb-2.text-white.text-left
                slot(name="preview")
                    | {{ preview || '' }}

</template>

<script lang="ts">
    import Vue from 'vue';
    export default Vue.extend({
        data() {
            return {
                isChecked: false,
            }
        },
        computed: {
            leftFlexGrow() {
                if (this.flexGrowLeft > 1) {
                    return this.flexGrowLeft;
                }

                return 3;
            },
            rightFlexGrow() {
                if (this.flexGrowRight > 1) {
                    return this.flexGrowRight;
                }

                return 1;
            },
            itemColor() {
                return this.color || '';
            },
        },
        props: {
            color: String,
            contentRightTop: String,
            contentRightBottom: String,
            dense: Boolean,
            expandable: Boolean,
            flexGrowLeft: Number,
            flexGrowRight: Number,
            highlightCardBorder: Boolean, // highlights the card border if true, currently set to a volie turquoise in CSS below
            icon: String, // the icon to be displayed in the left of the title
            isExpanded: Boolean,
            itemNumber: Number, // an integer to indentify the index of the item if this component is used with an array 
            onClickIsChecked: Function,
            onExpand: Function,
            preview: String,
            rightActionClick: Function,
            rightActionIcon: String,
            selectable: Boolean,
            subtitle: String,
            subtitleColor: String,
            title: String,
            titleAlignment: {
                type: String,
                default: 'left',
                validator: (value: string) => ['left', 'center', 'right'].includes(value)
            },
            appendNotesIconToTitle: Boolean, // appends a mdi notes icon to the title specifically to denote that a conference has notes in communication history for communication center
        },
    });
</script>

<style lang="scss" scoped>
    #app {
        .v-list-item__title {
            font-size: 1.15rem;
        }

        .v-list-item__subtitle {
            font-size: 1rem;
        }
    }

    .highlighted-border.v-card {
        outline: 2px solid var(--error) !important;
        outline-offset: -2px;
    }
</style>
